import axios from "axios";
import store from "../store";

export default () => {
  let headers = { "Auth-Token": store.state.ui.oaAuthToken };

  return axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: headers
  });
};
